import type { ModuleMigrationDef } from "@kubdee/sdk";

function createInvoiceTableSql(
  tableName: string,
  idxPrefix: string,
  defaultInvoiceType: string,
  defaultPartyType: string,
): string {
  return `
CREATE TABLE IF NOT EXISTS \`${tableName}\` (
  \`id\` text PRIMARY KEY NOT NULL,
  \`invoice_no\` text NOT NULL,
  \`company_id\` text NOT NULL,
  \`branch_id\` text,
  \`invoice_type\` text DEFAULT '${defaultInvoiceType}' NOT NULL,
  \`party_type\` text DEFAULT '${defaultPartyType}' NOT NULL,
  \`party_id\` text NOT NULL,
  \`invoice_date\` text NOT NULL,
  \`due_date\` text,
  \`subtotal\` real DEFAULT 0 NOT NULL,
  \`tax_amount\` real DEFAULT 0 NOT NULL,
  \`total_discount\` real DEFAULT 0,
  \`total_wht\` real DEFAULT 0,
  \`total\` real DEFAULT 0 NOT NULL,
  \`outstanding\` real DEFAULT 0 NOT NULL,
  \`doc_status\` integer DEFAULT 0 NOT NULL,
  \`status\` text DEFAULT 'draft' NOT NULL,
  \`credit_note_of\` text,
  \`debit_note_of\` text,
  \`reason\` text,
  \`original_invoice_amount\` real,
  \`corrected_amount\` real,
  \`difference_amount\` real,
  \`reason_code\` text,
  \`currency_code\` text DEFAULT 'THB',
  \`exchange_rate\` real DEFAULT 1,
  \`transaction_type\` text,
  \`delivery_date\` text,
  \`tax_point_date\` text,
  \`vat_status\` text DEFAULT 'due',
  \`vat_period\` text,
  \`remarks\` text,
  \`reference_module\` text,
  \`reference_doctype\` text,
  \`reference_id\` text,
  \`created_by\` text,
  \`created_at\` text NOT NULL,
  \`updated_at\` text NOT NULL,
  \`updated_by\` text,
  \`deleted_at\` text,
  \`deleted_by\` text,
  CONSTRAINT \`${tableName}_owner_chk\` CHECK (\`invoice_type\` = '${defaultInvoiceType}' AND \`party_type\` = '${defaultPartyType}')
);
CREATE UNIQUE INDEX IF NOT EXISTS \`${tableName}_invoice_no_unique\` ON \`${tableName}\` (\`invoice_no\`);
CREATE INDEX IF NOT EXISTS \`${idxPrefix}_company_status_idx\` ON \`${tableName}\` (\`company_id\`, \`status\`, \`invoice_date\`);
CREATE INDEX IF NOT EXISTS \`${idxPrefix}_company_party_idx\` ON \`${tableName}\` (\`company_id\`, \`party_type\`, \`party_id\`);
CREATE INDEX IF NOT EXISTS \`${idxPrefix}_company_type_idx\` ON \`${tableName}\` (\`company_id\`, \`invoice_type\`, \`status\`);
CREATE INDEX IF NOT EXISTS \`${idxPrefix}_company_branch_idx\` ON \`${tableName}\` (\`company_id\`, \`branch_id\`, \`status\`);
CREATE INDEX IF NOT EXISTS \`${idxPrefix}_credit_note_of_idx\` ON \`${tableName}\` (\`credit_note_of\`);
CREATE INDEX IF NOT EXISTS \`${idxPrefix}_debit_note_of_idx\` ON \`${tableName}\` (\`debit_note_of\`);
CREATE INDEX IF NOT EXISTS \`${idxPrefix}_company_vat_period_idx\` ON \`${tableName}\` (\`company_id\`, \`vat_period\`, \`vat_status\`);
CREATE INDEX IF NOT EXISTS \`${idxPrefix}_company_tax_point_idx\` ON \`${tableName}\` (\`company_id\`, \`tax_point_date\`, \`vat_status\`);
CREATE TRIGGER IF NOT EXISTS \`${tableName}_owner_insert_guard\` BEFORE INSERT ON \`${tableName}\` FOR EACH ROW WHEN NEW.\`invoice_type\` <> '${defaultInvoiceType}' OR NEW.\`party_type\` <> '${defaultPartyType}' BEGIN SELECT RAISE(ABORT, '${tableName} owner discriminator violation'); END;
CREATE TRIGGER IF NOT EXISTS \`${tableName}_owner_update_guard\` BEFORE UPDATE OF \`invoice_type\`, \`party_type\` ON \`${tableName}\` FOR EACH ROW WHEN NEW.\`invoice_type\` <> '${defaultInvoiceType}' OR NEW.\`party_type\` <> '${defaultPartyType}' BEGIN SELECT RAISE(ABORT, '${tableName} owner discriminator violation'); END;
  `.trim();
}

export const migration: ModuleMigrationDef = {
  key: "001_invoice_owner_tables",
  version: "1.1.0",
  sql: `
${createInvoiceTableSql("accounting_sales_invoices", "asi", "sales", "customer")}

${createInvoiceTableSql("accounting_purchase_invoices", "apinv", "purchase", "supplier")}

${createInvoiceTableSql("accounting_sales_credit_notes", "ascn", "credit_note", "customer")}

${createInvoiceTableSql("accounting_sales_debit_notes", "asdn", "debit_note", "customer")}

${createInvoiceTableSql("accounting_purchase_debit_notes", "apdn", "debit_note", "supplier")}
  `.trim(),
};
